export { default } from "./UserManagement.routes";
